"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var IUSREOU =
/*#__PURE__*/
function () {
  function IUSREOU(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, IUSREOU);
    var len, i;
    this.minLength = options.minLength || 8;
    this.maxLengthForValidateCheckSum = this.maxLengthForValidateCheckSum || 8;
    this.checkSum = {
      factors: [7, 1, 2, 3, 4, 5, 6],
      lowerLimit: 30000000,
      upperLimit: 60000000
    };
    this.value = null;

    if (value instanceof IUSREOU) {
      this.value = value.value;
    } else {
      this.value = String(value).replace(/\s+/g, '');
      len = this.value.length;
      /**
       * Если код не пустой, содержит не только 0 и меньшей длинны, чем минимальная, то добавим
       * вначало необходимое кол-во 0.
       */

      if (len && this.value != 0 && len < this.minLength) {
        for (i = this.minLength - len; i > 0; i--) {
          this.value = '0' + this.value;
        }
      }
    }

    if (!this.validate()) {
      this.value = null;
    }

    return this;
  }
  /**
   * @return {boolean}
   */


  (0, _createClass2["default"])(IUSREOU, [{
    key: "validate",
    value: function validate() {
      var length = this.value && this.value.length || 0;
      return !!(length && /^[0-9]+$/.test(this.value) && (
      /**
       * все нули.
       * Но существует счет 000000000
       */
      +this.value != 0 || length >= 9) && (
      /**
       * валидируем по контрольной сумме только значение с длинной maxLengthForValidateCheckSum
       */
      length > this.maxLengthForValidateCheckSum || this._isValidCheckSum()));
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.value || '';
    }
    /**
     * @description Правильная ли контрольная сумма
     * @return {boolean}
     * @private
     */

  }, {
    key: "_isValidCheckSum",
    value: function _isValidCheckSum() {
      var result = false,
          sum = 0,
          factors = this.checkSum.factors,
          lowerLimit = this.checkSum.lowerLimit,
          upperLimit = this.checkSum.upperLimit,
          i,

      /**
       * в подсчете учавствуют не все цифры
       */
      len = factors.length,
          factor,
          lastDigit,
          modulo,
          value = this.value;

      if (!isNaN(value)) {
        lastDigit = value[value.length - 1];

        for (i = 0; i < len; i++) {
          if (value > lowerLimit && value < upperLimit) {
            factor = factors[i];
          } else {
            factor = i + 1;
          }

          sum += value[i] * factor;
        }

        modulo = sum % 11;

        if (modulo > 10) {
          sum = 0;

          for (i = 0; i < len; i++) {
            if (value > lowerLimit && value < upperLimit) {
              factor = factors[i] + 2;
            } else {
              factor = i + 1 + 2;
            }

            sum += value[i] * factor;
          }

          modulo = sum % 11;
        }

        if (modulo === 10) {
          result = true;
        } else {
          /**
           * @description Результат деления должен совпадать с последней цифрой
           * @type {boolean}
           */
          result = modulo == lastDigit;
        }
      }

      return result;
    }
  }, {
    key: "is",
    value: function is() {
      console.warn('IUSREOU prototype.is() is deprecated.');
      return false;
    }
  }, {
    key: "toHtml",
    value: function toHtml() {
      console.warn('IUSREOU prototype.toHtml() is deprecated. Use .toString().');
      return this.toString();
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      console.warn('IUSREOU prototype.isDefault() is deprecated.');
      return false;
    }
  }]);
  return IUSREOU;
}();

var _default = IUSREOU;
exports["default"] = _default;